import React from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input";

interface Props {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
}
function Searchbar({ search, setSearch }: Props) {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value); // This should be the dispatch from parent (UsersTable)
  };

  return (
    <div className="relative">
      <Search className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
      <Input
        className="pl-8"
        placeholder="Search staff..."
        onChange={handleSearchChange}
        value={search}
      />
    </div>
  );
}

export default Searchbar;
